import { animate } from "animejs";

class Nav {
	constructor() {
		let cache = {};

		let initFunc = () => {
			initCache();
			setupParentMenuItems();
			registerEvents();
		};

		let initCache = () => {
			cache = {
				nav: document.querySelector(".nav"),
				navmobileBtn: document.querySelector(".nav_mobile"),
				navmobile: document.querySelector(".nav_mobile_menu"),
				menuItems: document.querySelectorAll(".menu-header > li"),
				mobileMenuItems: document.querySelectorAll(".menu-mobile > li"),
				parentMenuItems: document.querySelectorAll(
					".menu-header > li.menu-item-has-children"
				),
				mobileParentMenuItems: document.querySelectorAll(
					".menu-mobile > li.menu-item-has-children"
				),
				hashLinks: document.querySelectorAll('.menu-header a[href="#"]'),
				mobileHashLinks: document.querySelectorAll('.menu-mobile a[href="#"]'),
			};
		};

		let setupParentMenuItems = () => {
			if (cache.hashLinks && cache.hashLinks.length > 0) {
				cache.hashLinks.forEach((link) => {
					const parentLi = link.closest("li");
					if (
						parentLi &&
						parentLi.classList.contains("menu-item-has-children")
					) {
						parentLi.classList.add("parent-disabled");
					}
				});
			}

			if (cache.mobileHashLinks && cache.mobileHashLinks.length > 0) {
				cache.mobileHashLinks.forEach((link) => {
					const parentLi = link.closest("li");
					if (
						parentLi &&
						parentLi.classList.contains("menu-item-has-children")
					) {
						parentLi.classList.add("parent-disabled");
					}
				});
			}
		};

		let registerEvents = () => {
			if (cache.navmobileBtn) {
				cache.navmobileBtn.addEventListener("click", toggleMobileNav);
			}

			if (cache.parentMenuItems && cache.parentMenuItems.length > 0) {
				cache.parentMenuItems.forEach((item) => {
					const link = item.querySelector("a");
					if (link) {
						link.addEventListener("click", (e) => {
							if (link.getAttribute("href") === "#") {
								e.preventDefault();
							}

							toggleDropdown(item);
						});
					}
				});
			}

			if (cache.mobileParentMenuItems && cache.mobileParentMenuItems.length > 0) {
				cache.mobileParentMenuItems.forEach((item) => {
					const link = item.querySelector("a");
					if (link) {
						link.addEventListener("click", (e) => {
							if (link.getAttribute("href") === "#") {
								e.preventDefault();
							}

							toggleMobileDropdown(item);
						});
					}
				});
			}

			document.addEventListener("click", (e) => {
				if (!e.target.closest(".menu-item-has-children")) {
					closeAllDropdowns();
					closeAllMobileDropdowns();
				}
			});
		};

		let toggleDropdown = (menuItem) => {
			const isActive = menuItem.classList.contains("active");

			closeAllDropdowns();

			if (!isActive) {
				menuItem.classList.add("active");
			}
		};

		let closeAllDropdowns = () => {
			if (cache.parentMenuItems && cache.parentMenuItems.length > 0) {
				cache.parentMenuItems.forEach((item) => {
					item.classList.remove("active");
				});
			}
		};

		let toggleMobileDropdown = (menuItem) => {
			const isActive = menuItem.classList.contains("active");

			closeAllMobileDropdowns();

			if (!isActive) {
				menuItem.classList.add("active");
			}
		};

		let closeAllMobileDropdowns = () => {
			if (cache.mobileParentMenuItems && cache.mobileParentMenuItems.length > 0) {
				cache.mobileParentMenuItems.forEach((item) => {
					item.classList.remove("active");
				});
			}
		};

		let toggleMobileNav = () => {
			const isMobileNavOpen = cache.navmobileBtn.classList.contains("active");

			if (isMobileNavOpen) {
				closeMobileNav();
			} else {
				openMobileNav();
			}
		};

		let openMobileNav = () => {
			if (!cache.navmobile) return;

			cache.navmobileBtn.classList.add("active");
			cache.navmobile.style.display = "flex";
			document.querySelector("body").classList.add("overflow");
			document.querySelector("html").classList.add("overflow");

			animate(cache.navmobile, {
				opacity: [0, 1],
				translateX: [250, 0],
				duration: 400,
				ease: "outQuad",
			});
		};

		let closeMobileNav = () => {
			if (!cache.navmobile) return;

			cache.navmobileBtn.classList.remove("active");
			document.querySelector("body").classList.remove("overflow");
			document.querySelector("html").classList.remove("overflow");

			animate(cache.navmobile, {
				opacity: [1, 0],
				translateX: [0, 250],
				duration: 400,
				ease: "outQuad",
			});

			setTimeout(() => {
				cache.navmobile.style.display = "none";
			}, 400);
		};

		initFunc();
	}
}

export { Nav };
